<template>
  <div>
    <div class="colspan"
         id="dynamicsPC">
      <div class="top clearfix">
        <i></i>
        <p class="p1 clearfix">
          <i class="el-icon-s-order"></i> {{title}}
        </p>
      </div>
      <div class="content">
        <ul>
          <li v-for="item in infoList"
              :key="'aa'+item.id"
              @click="goto(item,item.id)">
            <p>{{item.title}}</p>
            <span>{{$dateToConver(item.publish_at)}}</span>
          </li>
        </ul>
      </div>
      <div class="page">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="page"
                       layout="prev, pager, next"
                       :page-size="page_size"
                       :total="total"
                       :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    default: ''
  },
  data () {
    return {
      infoList: [
      ],
      // title:'',
      page: 1,
      page_size: 10,
      total: 0,
      cate_id: null,
      id: null, //导航id
      // cate_id: [] ,//分类ID
      second_navId: null,//二级导航
    };
  },
  methods: {
    goto (item, id) {
      if (item.type == 4) {
        this.channelGoto(item)
        return false
      }
      if (this.second_navId) {
        this.$router.push({ name: "pubDetails", query: { newsId: id } });
      } else {
        this.$router.push({ name: "pubDetails", query: { newsId: id } });
      }

    },
    prev () {

    },

    //点击下一页和点击页码时执行
    handleCurrentChange (val) {
      this.getPageData();
    },
    //获取分页数据totalDataNumber
    // getPageData: function () {
    //     let that = this;
    //     // that.$db.post(this.$url.document.list,params).then(res=>{
    //     //     that.infoList = res.data.data
    //     //     that.total    = res.data.total
    //     // })
    // }.

    getPageData () {
      let that = this;
      let cate_id = '';
      if (this.cate_id) {
        cate_id = '&cate_id=' + this.cate_id
      }
      this.$db
        .get(
          this.$url.document.list +
          "?page=" +
          this.page +
          "&page_size=" +
          this.page_size + cate_id
        )
        .then(res => {
          that.infoList = res.data.data;
          that.total = res.data.total;
        }).catch(err => {
          console.log(err);
        });
    },

  },
  created () {
    this.cate_id = this.$route.query.cate_id;
    this.getPageData()

  },
  watch: {
    '$route.query.cate_id': function (value) {

      if (value) {
        this.cate_id = value
        this.page = 1
        this.getPageData()
      } else if (typeof (value)) {
        this.cate_id = ''
        this.getPageData()
      }
    },


  }
};
</script>
<style lang="less" scoped>
.colspan {
  // float: left;
  width: 950px;
  // min-height: 500px;
  overflow: hidden;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  position: relative;
  > .top {
    > i {
      width: 104px;
      height: 2px;
      position: absolute;
      left: 12px;
      top: 0;
    }
    > .p1 {
      float: left;
      padding-left: 12px;
      font-size: 20px;
      margin-bottom: 0;
    }
  }
  > .content {
    min-height: 500px;
    > ul {
      list-style-type: none;
      padding: 0;
      > li {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px dashed #ccc;
        color: #404040;
        font-size: 14px;
        margin: 0 30px;
        cursor: pointer;
        > p {
          float: left;
          margin: 0;
        }
        > span {
          float: right;
        }
      }
      > li:hover {
        background-color: #f5f5f5;
        border-bottom: 1px solid #f5f5f5;
      }
    }
  }
  > .page {
    // position: absolute;
    // left: 50%;
    // bottom: 50px;
    float: left;
    overflow: hidden;
    margin-left: 50%;
    margin-top: 20px;
    height: 100px;
    line-height: 100px;
    transform: translateX(-50%);
  }
  .page /deep/ .active {
    background-color: #d72324 !important;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d72324;
    color: #fff;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:hover {
    color: #d72324;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dynamics/pubContent.vue